import type { Event, ListItem, WithContext } from 'schema-dts'

const useAlgoliaEventCarouselSchema = (
  eventSchemas: WithContext<Event>[]
): any => {
  const schema = ref<WithContext<any> | undefined>(undefined)
  const script = computed(() => ({
    type: 'application/ld+json',
    innerHTML: schema.value,
  }))

  const createSchema = (): ListItem[] => {
    return eventSchemas.map((event, id) => {
      const obj: ListItem = {
        '@type': 'ListItem',
        position: id + 1,
        item: event,
      }

      return obj as ListItem
    })
  }

  schema.value = {
    '@context': 'https://schema.org',
    '@type': 'ItemList',
    itemListElement: createSchema(),
  }

  return {
    schema,
    script,
  }
}

export default useAlgoliaEventCarouselSchema
